@if (breachModel) {
    <div>
        @if (BreachTimerText) {
            <div class="detail-page-summary">
                <div class="row">
                    <div class="col-4">
                        <div class="property">
                            <b>{{ 'event.breachDetail.summaryDateOccurred' | transloco }}</b>
                            {{ breachModel.BreachOccurenceDateTime | dateFormat }}
                        </div>
                        <div class="property">
                            <b>{{ 'event.breachDetail.summaryDateDetected' | transloco }}</b>
                            {{ breachModel.BreachDetectionDateTime | dateTimeFormat }}
                        </div>
                        <div class="property">
                            <b>{{ 'event.breachDetail.summaryDateEndBreach' | transloco }}</b> {{ breachModel.BreachEndDateTime | dateFormat }}
                        </div>
                    </div>
                    <div class="col timer">
                        {{ BreachTimerText }}
                    </div>
                </div>
            </div>
        }

        @if (eventModel) {
            <div class="detail-page-card">
                <div class="detail-page-card-actions">
                    <button
                        data-uiid="event-db-isdatabreach"
                        class="btn btn-raised"
                        (click)="toggleDataBreach()"
                        [disabled]="!eventPermissions.canSave || breachPermissions.readonly"
                    >
                        <i
                            class="{{
                                eventModel.IsDataBreach ? 'fas fa-check-square' : 'far fa-square'
                            }}"
                        ></i>
                        <span>{{ 'event.breachDetail.isDataBreachBtn' | transloco }}</span>
                    </button>
                </div>
            </div>
        }

        @if (isTogglingDataBreach) {
            <div class="fancy-loader"></div>
        }

        @if ((eventModel && eventModel.IsDataBreach) || breachModel.ID > 0) {
            <form
                [formGroup]="parentForm"
                novalidate
                class="cerrix-control-sm"
                [class.breach-disabled-overlay]="!eventModel.IsDataBreach"
            >
                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'event.breachDetail.breachDetailsTitle' | transloco }}</div>
                    <div class="detail-page-card-body padded">
                        @if (sdHeavy) {
                            <div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="row">
                                            <div class="form-group col">
                                                <cerrix-textfield
                                                    fieldLabel="{{ 'event.breachDetail.internalBreachIdentifierFieldLabel' | transloco }}"
                                                    dataUiid="event-db-internalidentifier"
                                                    identifier="internalIdentifierInput"
                                                    formControlName="InternalBreachIdentifier"
                                                ></cerrix-textfield>
                                            </div>

                                            <div class="form-group col">
                                                <cerrix-textfield
                                                    fieldLabel="{{ 'event.breachDetail.externalBreachIdentifierFieldLabel' | transloco }}"
                                                    dataUiid="event-db-externalidentifier"
                                                    identifier="externalIdentifierInput"
                                                    formControlName="ExternalBreachIdentifier"
                                                ></cerrix-textfield>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group">
                                            <label for="organizationSelect">{{ 'event.breachDetail.organizationLabel' | transloco }}</label>
                                            <cerrix-select-tree
                                                data-uiid="event-db-organization"
                                                [tree]="sdHeavy.organizations"
                                                formControlName="OrganizationId"
                                                placeholder="Required"
                                                [multiselect]="false"
                                            >
                                            </cerrix-select-tree>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group">
                                            <label for="responsibleSelect"
                                                >{{ 'event.breachDetail.dataBreachResponsiblesLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-responsibles"
                                                id="breachResponsibleSelect"
                                                name="responsibleSelect"
                                                [items]="sdHeavy.responsibles"
                                                formControlName="ResponsibleList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                                placeholder="Required"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="assessorSelect"
                                                >{{ 'event.breachDetail.dataBreachAssessorsLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-assessors"
                                                id="breachAssessorSelect"
                                                name="assessorSelect"
                                                [items]="sdHeavy.assessors"
                                                formControlName="BreachAssessorList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="dataProtectionOfficerSelect"
                                                >{{ 'event.breachDetail.dataProtectionOfficerLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-protection"
                                                id="dataProtectionOfficerSelect"
                                                name="dataProtectionOfficerSelect"
                                                [items]="sdHeavy.officers"
                                                formControlName="DataProtectionOfficerId"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group">
                                            <label>{{ 'event.breachDetail.dateBreachOccurredLabel' | transloco }}</label>
                                            <date-input
                                                data-uiid="event-db-dateoccured"
                                                formControlName="BreachOccurenceDateTime"
                                                [maxDate]="maxDate"
                                            ></date-input>
                                        </div>

                                        <div class="form-group">
                                            <label>{{ 'event.breachDetail.dateBreachDetectedLabel' | transloco }}</label>
                                            <date-input
                                                data-uiid="event-db-datedetected"
                                                formControlName="BreachDetectionDateTime"
                                                (valueChange)="calculateDateTime()"
                                                [showTimePicker]="true"
                                                [maxDate]="maxDate"
                                            >
                                            </date-input>
                                        </div>

                                        <div class="form-group">
                                            <label>{{ 'event.breachDetail.dateEndOfBreachLabel' | transloco }}</label>
                                            <date-input
                                                data-uiid="event-db-dateendofbreach"
                                                formControlName="BreachEndDateTime"
                                                [maxDate]="maxDate"
                                            ></date-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="fancy-loader submodule"></div>
                        }
                    </div>
                </div>

                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'event.breachDetail.breachAnalysisTitle' | transloco }}</div>
                    <div class="detail-page-card-body padded">
                        @if (sdHeavy) {
                            <div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group">
                                            <label for="breachCategorySelect"
                                                >{{ 'event.breachDetail.natureOfBreachLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-natureofbreach"
                                                id="breachCategorySelect"
                                                name="breachCategorySelect"
                                                [items]="sdHeavy.breachCategories"
                                                formControlName="BreachCategoryList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="natureOfIncidentSelect"
                                                >{{ 'event.breachDetail.natureOfIncidentLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-natureofincident"
                                                id="natureOfIncidentSelect"
                                                name="natureOfIncidentSelect"
                                                [items]="sdHeavy.natureOfIncidents"
                                                formControlName="NatureOfIncidentId"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="true"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textarea
                                                fieldLabel="{{ 'event.breachDetail.descriptionOfBreachFieldLabel' | transloco }}"
                                                dataUiid="event-db-descriptionofbreach"
                                                identifier="breachDescriptionInput"
                                                formControlName="BreachDescription"
                                                placeholder="Required"
                                            ></cerrix-textarea>
                                        </div>

                                        <div class="form-group">
                                            <label for="typesOfBreachSelect">{{ 'event.breachDetail.typesOfBreachLabel' | transloco }}</label>
                                            <ng-select
                                                data-uiid="event-db-typesofbreach"
                                                id="typesOfBreachSelect"
                                                name="typesOfBreachSelect"
                                                [items]="sdHeavy.breachTypes"
                                                formControlName="BreachTypes"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [multiple]="true"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textarea
                                                fieldLabel="{{ 'event.breachDetail.causeOfBreachFieldLabel' | transloco }}"
                                                dataUiid="event-db-causeofbreach"
                                                identifier="causeOfbreachInput"
                                                formControlName="BreachCause"
                                                placeholder="Required"
                                            ></cerrix-textarea>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group">
                                            <cerrix-textarea
                                                fieldLabel="{{ 'event.breachDetail.preventativeMeasuresFieldLabel' | transloco }}"
                                                dataUiid="event-db-preventativemeasures"
                                                identifier="preventativeMeasuresInput"
                                                formControlName="PreventativeMeasures"
                                            ></cerrix-textarea>
                                        </div>

                                        <div class="form-group">
                                            <label for="ciaOfDataSelect"
                                                >{{ 'event.breachDetail.consequencesToCiaLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-consequencescia"
                                                id="ciaOfDataSelect"
                                                name="ciaOfDataSelect"
                                                [items]="sdHeavy.consequencesToCiaOfData"
                                                formControlName="ConsequencesToCiaOfDataList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [multiple]="true"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="personalBreachSelect"
                                                >{{ 'event.breachDetail.consequencesPersonalDataLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-consequencespersonal"
                                                id="personalBreachSelect"
                                                name="personalBreachSelect"
                                                [items]="sdHeavy.consequencesOfBreach"
                                                formControlName="DataBreachConsequences"
                                                [multiple]="true"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="personsInvolvedSelect"
                                                >{{ 'event.breachDetail.personsInvolvedLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-personsinvolved"
                                                id="personsInvolvedSelect"
                                                name="personsInvolvedSelect"
                                                [items]="sdHeavy.personsInvolvedTypes"
                                                formControlName="PersonsInvolvedList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [multiple]="true"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textarea
                                                fieldLabel="{{ 'event.breachDetail.descriptionPersonsInvolvedFieldLabel' | transloco }}"
                                                dataUiid="event-db-descriptionpersonsinvolved"
                                                identifier="personsInvolvedInput"
                                                formControlName="PersonsInvolvedDescription"
                                            ></cerrix-textarea>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group-separator"></div>

                                        <div class="form-group">
                                            <label for="personalDataSelect">{{ 'event.breachDetail.personalDataLabel' | transloco }}</label>
                                            <ng-select
                                                data-uiid="event-db-personaldata"
                                                id="personalDataSelect"
                                                name="personalDataSelect"
                                                [items]="sdHeavy.personalDataTypes"
                                                formControlName="PersonalDataTypes"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                                placeholder="Required"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="specialCatPersonalDataSelect"
                                                >{{ 'event.breachDetail.specialCategoriesLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-specialcategories"
                                                id="specialCatPersonalDataSelect"
                                                name="specialCatPersonalDataSelect"
                                                [items]="sdHeavy.specialPersonalDataTypes"
                                                formControlName="SensitivePersonalDataTypes"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'event.breachDetail.nameDataProcessorFieldLabel' | transloco }}"
                                                dataUiid="event-db-namedataprocessor"
                                                identifier="nameDataProcessorInput"
                                                formControlName="DataProcessorName"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 form-group">
                                                <cerrix-checkbox
                                                    data-uiid="event-db-outsourced"
                                                    formControlName="OutsourcedDataProcessing"
                                                    label="{{ 'event.breachDetail.outsourcedDataProcessingLabel' | transloco }}"
                                                    fontsize="0.9em"
                                                >
                                                </cerrix-checkbox>
                                            </div>
                                            <div class="col-6 form-group">
                                                <cerrix-checkbox
                                                    data-uiid="event-db-subdata"
                                                    formControlName="SubdataProcessor"
                                                    label="{{ 'event.breachDetail.subDataProcessorLabel' | transloco }}"
                                                    fontsize="0.9em"
                                                >
                                                </cerrix-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-none d-xl-block"></div>

                                        <div class="form-group">
                                            <label for="dataregistersInvolvedNumber"
                                                >{{ 'event.breachDetail.numDataRegistersLabel' | transloco }}</label
                                            >
                                            <input
                                                data-uiid="event-db-numberdataregisters"
                                                type="number"
                                                class="form-control form-control-sm"
                                                id="dataregistersInvolvedNumber"
                                                formControlName="NumberOfDataRegistersInvolved"
                                                step="1"
                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="minimumPersonsInvolvedNumber"
                                                >{{ 'event.breachDetail.minimumPersonsLabel' | transloco }}</label
                                            >
                                            <input
                                                data-uiid="event-db-minimumnumberofpersons"
                                                type="number"
                                                class="form-control form-control-sm"
                                                id="minimumPersonsInvolvedNumber"
                                                formControlName="NumberOfPersonsInvolvedMinimum"
                                                step="1"
                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="maximumPersonsInvolvedNumber"
                                                >{{ 'event.breachDetail.maximumPersonsLabel' | transloco }}</label
                                            >
                                            <input
                                                data-uiid="event-db-maximumnumberofpersons"
                                                type="number"
                                                class="form-control form-control-sm"
                                                id="maximumPersonsInvolvedNumber"
                                                formControlName="NumberOfPersonsInvolvedMaximum"
                                                step="1"
                                            />
                                        </div>

                                        <div class="row">
                                            <div class="col form-group">
                                                <cerrix-checkbox
                                                    data-uiid="event-db-personsothereu"
                                                    formControlName="PersonsInvolvedFromOtherEuCountries"
                                                    label="{{ 'event.breachDetail.personsOtherEuLabel' | transloco }}"
                                                    fontsize="0.9em"
                                                >
                                                </cerrix-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="fancy-loader submodule"></div>
                        }
                    </div>
                </div>

                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'event.breachDetail.notificationsTitle' | transloco }}</div>
                    <div class="detail-page-card-body padded">
                        @if (sdHeavy) {
                            <div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-authoritiesnotified"
                                                formControlName="AuthoritiesNotified"
                                            label="{{ 'event.breachDetail.authoritiesNotifiedLabel' | transloco }}"
                                                fontsize="0.9em"
                                                (valueChange)="authoritiesNotifiedChange($event)"
                                            >
                                            </cerrix-checkbox>
                                        </div>

                                        @if (parentForm.controls.AuthoritiesNotified.value) {
                                            <div class="form-group">
                                                <label>{{ 'event.breachDetail.dateAuthoritiesNotifiedLabel' | transloco }}</label>
                                                <date-input
                                                    data-uiid="event-db-dateauthoritiesnotified"
                                                    formControlName="AuthoritiesNotifiedDate"
                                                    (valueChange)="calculateDateTime()"
                                                    [showTimePicker]="true"
                                                    [maxDate]="maxDate"
                                                >
                                                </date-input>
                                            </div>
                                        }
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-xl-none"></div>
                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-intauthoritiesnotified"
                                                formControlName="InternationalAuthoritiesNotified"
                                            label="{{ 'event.breachDetail.intAuthoritiesNotifiedLabel' | transloco }}"
                                                fontsize="0.9em"
                                            >
                                            </cerrix-checkbox>
                                        </div>
                                        @if (
                                            parentForm.controls.InternationalAuthoritiesNotified
                                                .value
                                        ) {
                                            <div class="form-group">
                                                <cerrix-textfield
                                                    fieldLabel="{{ 'event.breachDetail.nameIntAuthFieldLabel' | transloco }}"
                                                    dataUiid="event-db-nameinternationalauthority"
                                                    identifier="nameInternationalAuthority"
                                                    formControlName="InternationalAuthoritiesName"
                                                ></cerrix-textfield>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group-separator"></div>
                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'event.breachDetail.whichEuCountryFieldLabel' | transloco }}"
                                                dataUiid="event-db-whicheucountry"
                                                identifier="whichEuCountryInput"
                                                formControlName="EUCountry"
                                            ></cerrix-textfield>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-none d-xl-block"></div>

                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-crossborderprocessing"
                                                formControlName="CrossborderProcessing"
                                            label="{{ 'event.breachDetail.crossborderProcessingLabel' | transloco }}"
                                                fontsize="0.9em"
                                            >
                                            </cerrix-checkbox>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group-separator"></div>

                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-notificationpersonsinvolved"
                                                formControlName="PersonsInvolvedNotified"
                                            label="{{ 'event.breachDetail.notificationPersonsInvolvedLabel' | transloco }}"
                                                fontsize="0.9em"
                                            >
                                            </cerrix-checkbox>
                                        </div>

                                        @if (parentForm.controls.PersonsInvolvedNotified.value) {
                                            <div class="form-group">
                                                <label for="personsInvNotDate"
                                                    >{{ 'event.breachDetail.dateNotificationPersonsLabel' | transloco }}</label
                                                >
                                                <date-input
                                                    data-uiid="event-db-datenotifications"
                                                    formControlName="PersonsInvolvedNotificationDate"
                                                    [maxDate]="maxDate"
                                                >
                                                </date-input>
                                            </div>

                                            <div class="form-group">
                                                <label for="personsInvolvedNotifiedNumber"
                                                    >{{ 'event.breachDetail.numPersonsNotifiedLabel' | transloco }}</label
                                                >
                                                <input
                                                    data-uiid="event-db-numberpersonsnotified"
                                                    type="number"
                                                    class="form-control form-control-sm"
                                                    id="personsInvolvedNotifiedNumber"
                                                    name="personsInvolvedNotifiedNumber"
                                                    formControlName="PersonsNotified"
                                                    min="0"
                                                />
                                            </div>
                                        } @else {
                                            <div class="form-group">
                                                <label for="reasonNoNotificationSelect"
                                                    >{{ 'event.breachDetail.reasonNoNotificationLabel' | transloco }}</label
                                                >
                                                <ng-select
                                                    data-uiid="event-db-reasonnonotification"
                                                    id="reasonNoNotificationSelect"
                                                    name="reasonNoNotificationSelect"
                                                    [items]="sdHeavy.noNotificationReasons"
                                                    formControlName="ReasonNoNotificationId"
                                                    bindLabel="Name"
                                                    bindValue="ID"
                                                    [closeOnSelect]="true"
                                                    [multiple]="false"
                                                >
                                                </ng-select>
                                            </div>
                                        }
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-none d-xl-block"></div>

                                        @if (parentForm.controls.PersonsInvolvedNotified.value) {
                                            <div class="form-group">
                                                <cerrix-textarea
                                                    fieldLabel="{{ 'event.breachDetail.descriptionNotificationFieldLabel' | transloco }}"
                                                    dataUiid="event-db-descriptionnotification"
                                                    identifier="personsInvNotiDescr"
                                                    formControlName="NotificationPersonsInvolved"
                                                >
                                                </cerrix-textarea>
                                            </div>
                                        } @else {
                                            <div class="form-group">
                                                <cerrix-textarea
                                                    fieldLabel="{{ 'event.breachDetail.explanationNoNotificationFieldLabel' | transloco }}"
                                                    dataUiid="event-db-explanationnonotification"
                                                    identifier="personsInvNoNotiExpl"
                                                    formControlName="ExplanationNoNotificationPersonsInvolved"
                                                >
                                                </cerrix-textarea>
                                            </div>
                                        }

                                        @if (parentForm.controls.PersonsInvolvedNotified.value) {
                                            <div class="form-group">
                                                <cerrix-textarea
                                                    fieldLabel="{{ 'event.breachDetail.meansOfCommunicationFieldLabel' | transloco }}"
                                                    dataUiid="event-db-meansofcommunication"
                                                    identifier="meansOfCommunicationInput"
                                                    formControlName="MeansOfCommunication"
                                                >
                                                </cerrix-textarea>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group-separator"></div>

                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-secondarynotification"
                                                formControlName="SecondaryNotificationNotified"
                                            label="{{ 'event.breachDetail.secondaryNotificationLabel' | transloco }}"
                                                fontsize="0.9em"
                                            >
                                            </cerrix-checkbox>
                                        </div>

                                        @if (parentForm.controls.SecondaryNotificationNotified) {
                                            <div class="form-group">
                                                <label for="secondaryNotDate"
                                                    >{{ 'event.breachDetail.dateSecondaryNotificationLabel' | transloco }}</label
                                                >
                                                <date-input
                                                    data-uiid="event-db-datesecondarynotification"
                                                    formControlName="SecondaryNotificationDate"
                                                    [maxDate]="maxDate"
                                                >
                                                </date-input>
                                            </div>
                                        }
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-none d-xl-block"></div>

                                        @if (parentForm.controls.SecondaryNotificationNotified) {
                                            <div class="form-group">
                                                <cerrix-textarea
                                                    fieldLabel="{{ 'event.breachDetail.descriptionSecondaryNotificationFieldLabel' | transloco }}"
                                                    dataUiid="event-db-descriptionsecondarynotification"
                                                    identifier="secondaryNotifiDescr"
                                                    formControlName="SecondaryNotificationDescription"
                                                >
                                                </cerrix-textarea>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="fancy-loader submodule"></div>
                        }
                    </div>
                </div>

                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'event.breachDetail.contactDetailsTitle' | transloco }}</div>
                    <div class="detail-page-card-body padded">
                        @if (sdHeavy) {
                            <div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'event.breachDetail.cocRegistrationNrFieldLabel' | transloco }}"
                                                dataUiid="event-db-cocnumber"
                                                identifier="cocRegistrationNumberInput"
                                                formControlName="RegistrationNr"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'event.breachDetail.organizationNameFieldLabel' | transloco }}"
                                                dataUiid="event-db-organizationname"
                                                identifier="organizationNameInput"
                                                formControlName="OrganizationName"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="form-group">
                                            <label for="activeSectorSelect"
                                                >{{ 'event.breachDetail.activeInWhichSectorLabel' | transloco }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-activeinsector"
                                                id="activeSectorSelect"
                                                name="activeSectorSelect"
                                                [items]="sdHeavy.whichSectors"
                                                formControlName="ActiveInWhichSectorId"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="true"
                                            >
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'event.breachDetail.zipCodeFieldLabel' | transloco }}"
                                                dataUiid="event-db-zipcode"
                                                identifier="zipCodeInput"
                                                formControlName="ZipCode"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'event.breachDetail.cityFieldLabel' | transloco }}"
                                                dataUiid="event-db-city"
                                                identifier="cityInput"
                                                formControlName="City"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'event.breachDetail.addressFieldLabel' | transloco }}"
                                                dataUiid="event-db-address"
                                                identifier="addressInput"
                                                formControlName="Address"
                                            ></cerrix-textfield>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="fancy-loader submodule"></div>
                        }
                    </div>
                </div>

                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'event.breachDetail.additionalInformationTitle' | transloco }}</div>
                    <div class="detail-page-card-body padded">
                        <div class="row">
                            <div class="col-12 col-xl-6 left-block">
                                <div class="form-group">
                                    <cerrix-textarea
                                        fieldLabel="{{ 'event.breachDetail.followUpDescriptionFieldLabel' | transloco }}"
                                        dataUiid="event-db-followupdescription"
                                        identifier="followUpDescriptionInput"
                                        formControlName="FollowUpDescription"
                                    >
                                    </cerrix-textarea>
                                </div>
                            </div>

                            <div class="col-12 col-xl-6 right-block">
                                <div class="form-group">
                                    <cerrix-textarea
                                        fieldLabel="{{ 'event.breachDetail.commentsFieldLabel' | transloco }}"
                                        dataUiid="event-db-comments"
                                        identifier="commentsInput"
                                        formControlName="Comments"
                                    ></cerrix-textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Custom fields -->
                @if (showCustomFields) {
                    <div class="detail-page-card">
                        <div class="detail-page-card-title">{{ 'event.breachDetail.customFieldsTitle' | transloco }}</div>
                        <div
                            class="detail-page-card-body padded form-group-styling cerrix-control-sm"
                        >
                            <cerrix-custom-fields-editor
                                [parentForm]="databreachCustomFieldsFormGroup"
                                [customFieldData]="databreachCustomFieldData"
                                [singleColumn]="false"
                            ></cerrix-custom-fields-editor>
                        </div>
                    </div>
                }
            </form>
        }
    </div>
} @else {
    <div class="fancy-loader"></div>
}
